'use strict';

bbw.guest.PasswordResetRequestCtrl = ngtk.controller.Base.extend({

    $inject: ['$scope', '$q', '$rootScope', 'rpcClient'],

    /**
     * @type {ngtk.rpcClient.Client}
     */
    _rpcClient: undefined,

    _init: function() {
        this.$scope.user = {};
        this.$scope.user_ = {};
    },

    onEmailChange: function() {
        delete this.$scope.user_.email_not_found;
    },

    request: function() {
        delete this.$scope.user_.errors;
        this.$scope.user_.processing = true;
        this._rpcClient.post('user/password-reset-request', this.$scope.user).
            execute().
            then(function() {
                this.$scope.ctrlStatus.finished = true;
            }.bind(this)).
            catch(function(err) {
                this.$scope.user_.email_not_found = 1;
            }.bind(this)).
            finally(function() {
                delete this.$scope.user_.processing;
            }.bind(this));
    }

});
